import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0 mb-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = { class: "card card-body mb-0" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_8 = { class: "col p-0" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_11 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_12 = { class: "col p-0" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_15 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_16 = { class: "col p-0" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = { class: "form-group mb-2 col" }
const _hoisted_19 = { class: "col-auto p-0 text-end" }
const _hoisted_20 = { class: "row m-4 mb-0 mt-0" }
const _hoisted_21 = { class: "col-sm-12" }
const _hoisted_22 = { class: "card card-body mb-0" }
const _hoisted_23 = { class: "overflow-auto" }
const _hoisted_24 = { class: "table table-bordered align-middle text-left text-nowrap position-relative" }
const _hoisted_25 = { class: "bg-light" }
const _hoisted_26 = {
  class: "text-capitalize-first",
  rowspan: "2"
}
const _hoisted_27 = {
  class: "text-capitalize-first",
  rowspan: "2"
}
const _hoisted_28 = {
  class: "text-capitalize-first",
  rowspan: "2"
}
const _hoisted_29 = {
  class: "text-capitalize-first",
  rowspan: "2"
}
const _hoisted_30 = {
  class: "text-capitalize-first",
  rowspan: "2"
}
const _hoisted_31 = {
  class: "text-capitalize-first",
  colspan: "3"
}
const _hoisted_32 = {
  class: "text-capitalize-first",
  colspan: "5"
}
const _hoisted_33 = {
  class: "text-capitalize-first",
  colspan: "5"
}
const _hoisted_34 = {
  class: "text-capitalize-first",
  colspan: "3"
}
const _hoisted_35 = {
  class: "text-capitalize-first",
  rowspan: "2"
}
const _hoisted_36 = {
  class: "text-capitalize-first",
  rowspan: "2"
}
const _hoisted_37 = { class: "bg-light" }
const _hoisted_38 = { class: "text-capitalize-first" }
const _hoisted_39 = { class: "text-capitalize-first" }
const _hoisted_40 = { class: "text-capitalize-first" }
const _hoisted_41 = { class: "text-capitalize-first" }
const _hoisted_42 = { class: "text-capitalize-first" }
const _hoisted_43 = { class: "text-capitalize-first" }
const _hoisted_44 = { class: "text-capitalize-first" }
const _hoisted_45 = { class: "text-capitalize-first" }
const _hoisted_46 = { class: "text-capitalize-first" }
const _hoisted_47 = { class: "text-capitalize-first" }
const _hoisted_48 = { class: "text-capitalize-first" }
const _hoisted_49 = { class: "text-capitalize-first" }
const _hoisted_50 = { class: "text-capitalize-first" }
const _hoisted_51 = { class: "text-capitalize-first" }
const _hoisted_52 = { class: "text-capitalize-first" }
const _hoisted_53 = { class: "text-capitalize-first" }
const _hoisted_54 = { class: "text-end" }
const _hoisted_55 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_DatePicker, {
                          modelValue: _ctx.requestDTO.fromDate,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.requestDTO.fromDate) = $event)),
                          mode: "dateTime",
                          "model-modifiers": {string: true},
                          is24hr: "",
                          masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                        }, {
                          default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                            _createElementVNode("input", {
                              class: "form-control form-control-sm",
                              placeholder: _ctx.helper.trans('labels.from_date'),
                              value: inputValue,
                              onFocus: togglePopover,
                              onChange: inputEvents.change
                            }, null, 40, _hoisted_10)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_DatePicker, {
                          modelValue: _ctx.requestDTO.toDate,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requestDTO.toDate) = $event)),
                          mode: "dateTime",
                          "model-modifiers": {string: true},
                          is24hr: "",
                          masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                        }, {
                          default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                            _createElementVNode("input", {
                              class: "form-control form-control-sm",
                              placeholder: _ctx.helper.trans('labels.to_date'),
                              value: inputValue,
                              onFocus: togglePopover,
                              onChange: inputEvents.change
                            }, null, 40, _hoisted_14)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_Multiselect, {
                          id: "statuses",
                          class: "multiselect-sm",
                          modelValue: _ctx.requestDTO.status,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.requestDTO.status) = $event)),
                          options: Object.values(_ctx.PartnerIncomesStatuses).filter(item => item === parseInt(item)),
                          "custom-label": (opt) => _ctx.helper.trans(`partner_incomes.status.${opt}`),
                          multiple: false,
                          "select-label": "Select",
                          placeholder: _ctx.helper.trans('labels.status')
                        }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[3] || (_cache[3] = _withModifiers(() => _ctx.applyFilters(), ["prevent"])),
                        class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.apply')), 1),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[4] || (_cache[4] = _withModifiers(() => _ctx.clearFilters(), ["prevent"])),
                        class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.reset')), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("table", _hoisted_24, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_25, [
                    _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.helper.trans('labels.id')), 1),
                    _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.helper.trans('labels.name')), 1),
                    _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.helper.trans('labels.status')), 1),
                    _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.helper.trans('labels.date')), 1),
                    _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.helper.trans('labels.turnover_currency')), 1),
                    _createElementVNode("th", _hoisted_31, _toDisplayString(_ctx.helper.trans('labels.revenue_total_amount')), 1),
                    _createElementVNode("th", _hoisted_32, _toDisplayString(_ctx.helper.trans('labels.turnover_in_total_amount')), 1),
                    _createElementVNode("th", _hoisted_33, _toDisplayString(_ctx.helper.trans('labels.turnover_out_total_amount')), 1),
                    _createElementVNode("th", _hoisted_34, _toDisplayString(_ctx.helper.trans('labels.withdrawal_fee_total_amount')), 1),
                    _createElementVNode("th", _hoisted_35, _toDisplayString(_ctx.helper.trans('labels.debt_amount')), 1),
                    _createElementVNode("th", _hoisted_36, _toDisplayString(_ctx.helper.trans('labels.total_income_amount')), 1),
                    _cache[7] || (_cache[7] = _createElementVNode("th", { rowspan: "2" }, null, -1))
                  ]),
                  _createElementVNode("tr", _hoisted_37, [
                    _createElementVNode("th", _hoisted_38, _toDisplayString(_ctx.helper.trans('labels.sum')), 1),
                    _createElementVNode("th", _hoisted_39, _toDisplayString(_ctx.helper.trans('labels.share')), 1),
                    _createElementVNode("th", _hoisted_40, _toDisplayString(_ctx.helper.trans('labels.income')), 1),
                    _createElementVNode("th", _hoisted_41, _toDisplayString(_ctx.helper.trans('labels.turnover_completed_amount')), 1),
                    _createElementVNode("th", _hoisted_42, _toDisplayString(_ctx.helper.trans('labels.turnover_canceled_amount')), 1),
                    _createElementVNode("th", _hoisted_43, _toDisplayString(_ctx.helper.trans('labels.turnover_net_amount')), 1),
                    _createElementVNode("th", _hoisted_44, _toDisplayString(_ctx.helper.trans('labels.share')), 1),
                    _createElementVNode("th", _hoisted_45, _toDisplayString(_ctx.helper.trans('labels.income')), 1),
                    _createElementVNode("th", _hoisted_46, _toDisplayString(_ctx.helper.trans('labels.turnover_completed_amount')), 1),
                    _createElementVNode("th", _hoisted_47, _toDisplayString(_ctx.helper.trans('labels.turnover_canceled_amount')), 1),
                    _createElementVNode("th", _hoisted_48, _toDisplayString(_ctx.helper.trans('labels.turnover_net_amount')), 1),
                    _createElementVNode("th", _hoisted_49, _toDisplayString(_ctx.helper.trans('labels.share')), 1),
                    _createElementVNode("th", _hoisted_50, _toDisplayString(_ctx.helper.trans('labels.income')), 1),
                    _createElementVNode("th", _hoisted_51, _toDisplayString(_ctx.helper.trans('labels.sum')), 1),
                    _createElementVNode("th", _hoisted_52, _toDisplayString(_ctx.helper.trans('labels.share')), 1),
                    _createElementVNode("th", _hoisted_53, _toDisplayString(_ctx.helper.trans('labels.income')), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.response.items, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      class: _normalizeClass({'date-group-start': _ctx.isDateGroupStart(index)})
                    }, [
                      _createElementVNode("td", null, _toDisplayString(item.id), 1),
                      _createElementVNode("td", null, _toDisplayString(item.userName), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.helper.trans(`partner_incomes.status.${item.status}`)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.dateHelper.format(item.date, 'YYYY-MM-DD')), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.turnoverCurrencyLabel(item.turnoverCurrency)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatAmount(item.revenueTotalAmount, 2)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.helper.floatToPercent(item.revenueShare), 2)) + "%", 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatAmount(item.revenueIncomeAmount)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatAmount(item.turnoverInTotalAmount, 2)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatAmount(item.turnoverInCanceledAmount, 2)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatAmount(_ctx.netAmount(item.turnoverInTotalAmount, item.turnoverInCanceledAmount), 2)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.helper.floatToPercent(item.turnoverInShare), 2)) + "%", 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatAmount(item.turnoverInIncomeAmount)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatAmount(item.turnoverOutTotalAmount, 2)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatAmount(item.turnoverOutCanceledAmount, 2)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatAmount(_ctx.netAmount(item.turnoverOutTotalAmount, item.turnoverOutCanceledAmount), 2)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.helper.floatToPercent(item.turnoverOutShare), 2)) + "%", 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatAmount(item.turnoverOutIncomeAmount)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatAmount(item.withdrawalFeeTotalAmount, 2)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.helper.floatToPercent(item.withdrawalFeeShare), 2)) + "%", 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatAmount(item.withdrawalFeeIncomeAmount)), 1),
                      _createElementVNode("td", {
                        class: _normalizeClass({'text-danger': _ctx.hasAmount(item.debtAmount)})
                      }, _toDisplayString(_ctx.formatAmount(item.debtAmount)), 3),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatAmount(item.totalIncomeAmount)), 1),
                      _createElementVNode("td", _hoisted_54, [
                        (_ctx.isAdmin && item.status === _ctx.PartnerIncomesStatuses.NEW)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              onClick: ($event: any) => (_ctx.processIncome(item.id)),
                              class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize me-2"
                            }, _toDisplayString(_ctx.helper.trans('button.process_deposit')), 9, _hoisted_55))
                          : _createCommentVNode("", true)
                      ])
                    ], 2))
                  }), 256))
                ])
              ]),
              (_ctx.response.totalCount > _ctx.response.items.length)
                ? (_openBlock(), _createBlock(_component_b_pagination, {
                    key: 0,
                    modelValue: _ctx.page,
                    "onUpdate:modelValue": [
                      _cache[5] || (_cache[5] = ($event: any) => ((_ctx.page) = $event)),
                      _cache[6] || (_cache[6] = ($event: any) => (_ctx.load()))
                    ],
                    "total-rows": _ctx.response.totalCount,
                    "per-page": _ctx.response.limit,
                    limit: 20,
                    "prev-text": "Back",
                    "next-text": "Next",
                    align: "start",
                    "first-number": "",
                    "hide-goto-end-buttons": "",
                    "hide-ellipsis": ""
                  }, null, 8, ["modelValue", "total-rows", "per-page"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createVNode(_component_ConfirmModal, { ref: "confirmModal" }, null, 512)
    ]),
    _: 1
  }, 512))
}